import * as React from 'react';
import { Tabs, TabsList, TabsTrigger } from '../../core/tabs';
import { cn } from '../../../utils';

export type SegmentTabItem = { value: string; label: string; count?: number };

type SegmentTabsProps = {
  value: string;
  onValueChange: (value: string) => void;
  items: SegmentTabItem[];
  className?: string;
  'aria-label'?: string;
};

/** Pill tabs above a list — the segments people switch between most. */
export function SegmentTabs({ value, onValueChange, items, className, 'aria-label': ariaLabel }: SegmentTabsProps) {
  return (
    <Tabs value={value} onValueChange={onValueChange} className={cn('w-full overflow-x-auto', className)}>
      <TabsList aria-label={ariaLabel} className="h-auto w-max flex-wrap justify-start gap-1 rounded-full bg-muted/70 p-1">
        {items.map((item) => (
          <TabsTrigger
            key={item.value}
            value={item.value}
            className="rounded-full px-3.5 py-1.5 data-[state=active]:bg-background data-[state=active]:shadow-sm"
          >
            {item.label}
            {item.count !== undefined ? (
              <span
                className={cn(
                  'ml-1.5 inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-[11px] font-semibold tabular-nums',
                  value === item.value ? 'bg-primary text-primary-foreground' : 'bg-background/80 text-muted-foreground',
                )}
              >
                {item.count}
              </span>
            ) : null}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
